export default __webpack_public_path__ + "131bdd96eb4f428a9023c12ed23ea782.png";